import { render, staticRenderFns } from "./AccountCapLimitBtn.vue?vue&type=template&id=7c153e48&scoped=true&"
import script from "./AccountCapLimitBtn.vue?vue&type=script&lang=js&"
export * from "./AccountCapLimitBtn.vue?vue&type=script&lang=js&"
import style0 from "./AccountCapLimitBtn.vue?vue&type=style&index=0&id=7c153e48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c153e48",
  null
  
)

export default component.exports